import { skuKey, skuTable } from "./sku-lookup";
import { ApiArticles } from "src/api/api-data-manager";
import { tableOptions } from "src/definitions/table-data";
import { chairOptions } from "src/definitions/chair-data";
import {
	MaterialTheme,
	tableTypeUniverse,
	seatingTypeUniverse,
	materialThemeUniverse,
	materialThemes,
	isThemeValidForProduct,
} from "src/definitions/type-definitions";

export function isArticleInStock(
	sku: string,
	apiArticles: ApiArticles,
): boolean {
	const article = apiArticles[sku];
	return (
		!!article && article.priceWithVat !== 0 && article.priceWithoutVat !== 0
	);
}

export function generateProductsInStockDomain(
	apiArticles: ApiArticles,
	isDev: boolean,
): Record<string, MaterialTheme[]> {
	const result: Record<string, MaterialTheme[]> = {};
	const allTypes = [...tableTypeUniverse, ...seatingTypeUniverse];

	for (const productType of allTypes) {
		const opts =
			tableOptions[productType as keyof typeof tableOptions] ??
			chairOptions[productType as keyof typeof chairOptions];
		const inStock: MaterialTheme[] = [];

		for (const theme of materialThemeUniverse) {
			if (theme === "theme-none") {
				continue;
			}
			const def = materialThemes[theme];
			if (!isThemeValidForProduct(def, opts)) {
				continue;
			}

			const sku = skuTable[skuKey(productType, def.wood, def.metal)];
			if (!sku) {
				continue;
			}

			if (isDev || isArticleInStock(sku, apiArticles)) {
				inStock.push(theme);
			}
		}
		result[productType] = inStock;
	}
	return result;
}

/**
 * Check whether a product's currently selected theme is in stock.
 * Returns true when theme-none (always valid) or when stock data
 * hasn't loaded yet (domain contains full universe).
 */
export function isProductThemeInStock(
	theme: string,
	inStockDomain: unknown[],
): boolean {
	if (theme === "theme-none") {
		return true;
	}
	return inStockDomain.length > 0 && inStockDomain.includes(theme);
}
